const imageAttrsDefaults = {
  width: 0,
  height: 0,
  focalPoint: [0.5, 0.5],
  altText: '',
}

export default imageAttrsDefaults